import { render, staticRenderFns } from "./page-list-header.vue?vue&type=template&id=420cf92f"
import script from "./page-list-header.vue?vue&type=script&lang=js"
export * from "./page-list-header.vue?vue&type=script&lang=js"
import style0 from "./page-list-header.vue?vue&type=style&index=0&id=420cf92f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports